export const WHERE_NOT_ASSOCIATED_TO_OT = 'WorkOrderId IS NULL';

export const INCIDENT_WHERE_WITH_ASSIGNED_WORK = `${WHERE_NOT_ASSOCIATED_TO_OT} AND WorkOrderMaintenanceWorkId IS NOT NULL`;

export const INCIDENT_WHERE_WITHOUT_ASSIGNED_WORK = `${WHERE_NOT_ASSOCIATED_TO_OT} AND WorkOrderMaintenanceWorkId IS NULL`;

export const ALERT_CHECKLIST_WHERE_WITH_ASSIGNED_WORK = `${WHERE_NOT_ASSOCIATED_TO_OT} AND MaintenanceWorkId IS NOT NULL`;

export const ALERT_CHECKLIST_WHERE_WITHOUT_ASSIGNED_WORK = `${WHERE_NOT_ASSOCIATED_TO_OT} AND MaintenanceWorkId IS NULL`;
